import { Component, Prop, Host, h } from '@stencil/core';

/**
 * The card content component is used to add proper padding to a card.  
 */
/**
 * @part content - This part is the full content block.
 */
@Component({
  tag: 'som-content',
  styleUrl: 'som-content.scss',
  shadow: true
})
export class SomContent {

  //TODO: this should link to docs about spacing sizes
  /**
   * This property controls the amount of padding added to the card content.
   */
  @Prop() padding: string;

  render() {
    return (
      <Host>
        <div class={`content ${(this.padding) ? `p-${this.padding}` : ''}`} part="content">
          <slot />
        </div>
      </Host>
    );
  }
}
